import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="datahub-team"
export default class extends Controller {
  connect() {
  }
}
